module.exports = __webpack_public_path__ + "static/media/DSC00778.14fd5e36.jpg";